var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImacPro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 54,
    viewBox: "0 0 43 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 54
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1F",
    fillRule: "nonzero",
    d: "M41.5,14 L1.5,14 C0.671572875,14 0,14.6715729 0,15.5 L0,41.5 C0,42.3284271 0.671572875,43 1.5,43 L41.5,43 C42.3284271,43 43,42.3284271 43,41.5 L43,15.5 C43,15.1021753 42.8419647,14.7206444 42.5606602,14.4393398 C42.2793556,14.1580353 41.8978247,14 41.5,14 Z M27,43.5 L27,50 L16,50 L16,43.5 L27,43.5 Z M42,15 L42,38 L1,38 L1,15 L42,15 Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImacPro);
export default __webpack_public_path__ + "static/media/imacPro.4f9bda42995e9b0e63bec0792fc6e271.svg";
export { ForwardRef as ReactComponent };